export const HOTSPOT_CLICKED = '|A|InteractiveElements.HOTSPOT_CLICKED'
export const HOTSPOT_MODAL_SCROLLED = '|A|InteractiveElements.HOTSPOT_MODAL_SCROLLED'
export const HOTSPOT_MOUSE_ENTERED = '|A|InteractiveElements.HOTSPOT_MOUSE_ENTERED'
export const HOTSPOT_MOUSE_EXITED = '|A|InteractiveElements.HOTSPOT_MOUSE_EXITED'
export const HOTSPOT_MEDIA_VIEWED = '|A|InteractiveElements.HOTSPOT_MEDIA_VIEWED'

import { InteractiveElementActions } from 'aria-viewer/interactive-element'

export const hotspotClicked = () => ({
    type: HOTSPOT_CLICKED,
})

export const hotspotModalScrolled = ({ hotspotType }) => ({
    type: HOTSPOT_MODAL_SCROLLED,
    hotspotType,
})

export const hotspotMouseEntered = () => ({
    type: HOTSPOT_MOUSE_ENTERED,
})

export const hotspotMouseExited = () => ({
    type: HOTSPOT_MOUSE_EXITED,
})

export const hotspotMediaViewed = ({ hotspotType }) => ({
    type: HOTSPOT_MEDIA_VIEWED,
    hotspotType,
})

export const setHotspotCoordinates = hotspotCoordinates => ({
    type: InteractiveElementActions.SET_HOTSPOT_COORDINATES,
    hotspotCoordinates,
})

// TODO : this shouldn't be in actions constants
export const HOTSPOT_TYPES = {
    panorama: 'panorama',
    video: 'video',
    video360: '360 video',
    photo: 'photo',
    tooltip: 'tooltip',
}
